{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "core/query-pagination-numbers",
	"title": "Page Numbers",
	"category": "theme",
	"parent": [ "core/query-pagination" ],
	"description": "Displays a list of page numbers for pagination.",
	"textdomain": "default",
	"attributes": {
		"midSize": {
			"type": "number",
			"default": 2
		}
	},
	"usesContext": [ "queryId", "query", "enhancedPagination" ],
	"supports": {
		"anchor": true,
		"reusable": false,
		"html": false,
		"color": {
			"gradients": true,
			"text": false,
			"__experimentalDefaultControls": {
				"background": true
			}
		},
		"typography": {
			"fontSize": true,
			"lineHeight": true,
			"__experimentalFontFamily": true,
			"__experimentalFontWeight": true,
			"__experimentalFontStyle": true,
			"__experimentalTextTransform": true,
			"__experimentalTextDecoration": true,
			"__experimentalLetterSpacing": true,
			"__experimentalDefaultControls": {
				"fontSize": true
			}
		},
		"interactivity": {
			"clientNavigation": true
		}
	},
	"editorStyle": "wp-block-query-pagination-numbers-editor"
}
